module.exports = __webpack_public_path__ + "static/media/agency_sidebar_bg.9b857f21.jpg";